<script>
  import Text from '@components/general/text.svelte'
  import { cn } from '@lib/utils'
  
  let { title, subtitle, subtitleContent, icons, class: className, buttons } = $props()
</script>

<!-- We use a negative margin to pull the titles area up, we prefer this as it allows keeping a top padding on the content area in case titles are not present -->
<header class={cn("flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 sm:gap-2 px-4 pt-6 sm:px-8 sm:pt-8 -mb-2", className)}>

  <!-- Titles area -->
  <div class="flex flex-col gap-[2px] ">

    <!-- The title -->
    <Text variant="title" text={title} as="h1" />
    
    <!-- The subtitle -->
    {#if subtitleContent}
      {@render subtitleContent()}
    {:else if subtitle}
      <Text variant="subtitle" text={subtitle} as="p" />
    {/if}
    
  </div>

  {#if buttons}
    <div class="flex items-center gap-2">
      {@render buttons()}
    </div>
  {/if}
  
</header>